import apiClient from './apiClient';

export const subscriptionService = {
  getAllPlans: async () => {
    try {
      const response = await apiClient.get('/api/v1/subscription/plans');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching subscription plans, using static data:', error);
      return staticPlans;
    }
  },

  registerVendor: async (registrationData) => {
    try {
      const response = await apiClient.post('/api/v1/subscription/register-vendor', registrationData);
      return response.data;
    } catch (error) {
      console.error('Error registering vendor:', error);
      throw error;
    }
  },

  // NEW: Process payment and register vendor
  processPaymentAndRegister: async (registrationData) => {
    try {
      const response = await apiClient.post('/api/v1/payment-registration/process', registrationData);
      return response.data;
    } catch (error) {
      console.error('Error processing payment and registration:', error);
      throw error;
    }
  },

  getVendorSubscription: async (vendorId) => {
    try {
      const response = await apiClient.get(`/api/v1/subscription/vendor/${vendorId}/subscription`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching vendor subscription:', error);
      throw error;
    }
  },

  changeSubscription: async (vendorId, planId) => {
    try {
      const response = await apiClient.post(`/api/v1/subscription/vendor/${vendorId}/subscription/change`, {
        plan_id: planId
      });
      return response.data;
    } catch (error) {
      console.error('Error changing subscription:', error);
      throw error;
    }
  },

  getTrialStatus: async (vendorId) => {
    try {
      const response = await apiClient.get(`/api/v1/subscription/vendor/${vendorId}/trial-status`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching trial status:', error);
      throw error;
    }
  },

  calculatePricing: async (planId, countryId, billingCycle = 'monthly') => {
    try {
      const response = await apiClient.post('/api/v1/subscription/calculate-pricing', {
        plan_id: planId,
        country_id: countryId,
        billing_cycle: billingCycle
      });
      return response.data.data;
    } catch (error) {
      console.error('Error calculating pricing:', error);
      throw error;
    }
  },

  processPayment: async (paymentData) => {
    try {
      const response = await apiClient.post('/api/v1/subscription/process-payment', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error processing payment:', error);
      throw error;
    }
  },

  getPaymentHistory: async (vendorId) => {
    try {
      const response = await apiClient.get(`/api/v1/subscription/vendor/${vendorId}/payment-history`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching payment history:', error);
      throw error;
    }
  }
};

export const staticPlans = [
  {
    plan_id: 1,
    plan_name: 'Free',
    plan_type: 'free',
    monthly_price: 0.00,
    yearly_price: 0.00,
    trial_days: 0,
    max_branches: 1,
    max_users: 2,
    max_products: 50,
    features: {
      ai_insights: false,
      analytics: 'basic',
      support: 'community',
      integrations: false
    }
  },
  {
    plan_id: 2,
    plan_name: 'Basic',
    plan_type: 'paid',
    monthly_price: 29.99,
    yearly_price: 299.90,
    trial_days: 30,
    max_branches: 3,
    max_users: 10,
    max_products: 500,
    features: {
      ai_insights: true,
      analytics: 'advanced',
      support: 'email',
      integrations: true
    }
  },
  {
    plan_id: 3,
    plan_name: 'Pro',
    plan_type: 'paid',
    monthly_price: 59.99,
    yearly_price: 599.90,
    trial_days: 30,
    max_branches: 10,
    max_users: 50,
    max_products: 2000,
    features: {
      ai_insights: true,
      analytics: 'premium',
      support: 'priority',
      integrations: true,
      api_access: true
    }
  },
  {
    plan_id: 4,
    plan_name: 'Enterprise',
    plan_type: 'paid',
    monthly_price: 149.99,
    yearly_price: 1499.90,
    trial_days: 30,
    max_branches: -1,
    max_users: -1,
    max_products: -1,
    features: {
      ai_insights: true,
      analytics: 'premium',
      support: 'dedicated',
      integrations: true,
      api_access: true,
      custom_features: true
    }
  }
];